module.exports = __webpack_public_path__ + "static/img/registerbg.3611ebc1.jpg";